import { Link } from 'react-router-dom';

export default function ContentSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <p className="text-xs tracking-[0.2em] uppercase text-foreground-500 font-label mb-3">Itaobuy Sheet Knowledge</p>
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground-900 leading-tight mb-4">
          La Guida
          <br />
          <span className="font-heading italic font-normal">Definitiva</span>
          <br />
          2026
        </h2>
        <p className="text-foreground-600 text-base md:text-lg mb-14 max-w-[600px]">
          Strategie intelligenti per lo shopping online
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link
            to="/articoli/itaobuy-spreadsheet-per-principianti"
            onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}
            className="group relative rounded-2xl bg-accent-100/80 p-8 md:p-10 min-h-[280px] flex flex-col justify-between overflow-hidden transition-transform duration-300 hover:scale-[1.01] cursor-pointer"
          >
            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-6">
              <i className="ri-arrow-right-up-line text-accent-600 text-xl"></i>
            </div>
            <div>
              <p className="text-5xl md:text-6xl font-heading font-bold text-accent-800 mb-3">100%</p>
              <p className="text-foreground-800 text-lg md:text-xl font-heading font-semibold mb-2">
                itaobuy sheet per principianti
              </p>
              <p className="text-foreground-600 text-sm">guida aggiornata</p>
            </div>
            <p className="mt-6 text-accent-700 font-heading italic text-lg">Inizia ora &rarr;</p>
          </Link>

          <Link
            to="/articoli/itaobuy-spreadsheet-strategie-avanzate"
            onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}
            className="group relative rounded-2xl bg-secondary-100/80 p-8 md:p-10 min-h-[280px] flex flex-col justify-between overflow-hidden transition-transform duration-300 hover:scale-[1.01] cursor-pointer"
          >
            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-6">
              <i className="ri-arrow-right-up-line text-secondary-600 text-xl"></i>
            </div>
            <div>
              <p className="text-5xl md:text-6xl font-heading font-bold text-secondary-800 mb-3">7</p>
              <p className="text-foreground-800 text-lg md:text-xl font-heading font-semibold mb-2">
                strategie avanzate
              </p>
              <p className="text-foreground-600 text-sm">tecniche per utenti esperti</p>
            </div>
            <p className="mt-6 text-secondary-700 font-heading italic text-lg">Scopri di più &rarr;</p>
          </Link>
        </div>
      </div>
    </section>
  );
}